import Constants from '@/Constants';
import React, { useEffect, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import './style.scss';

interface Props {
    label?: string;
    toolTip?: string;
    initialValue?: boolean;
    disabled?: boolean;
    onChange: CallableFunction;
    style?: React.CSSProperties;
}

const InputCheckboxWithTooltip: React.FC<Props> = (props: Props, {}) => {
    const { label, toolTip, initialValue = false, disabled = false, onChange, style } = props;

    const [checked, setChecked] = useState<boolean>(initialValue);

    useEffect(() => {
        onChange(checked);
    }, [checked]);

    useEffect(() => {
        setChecked(initialValue);
    }, [initialValue]);

    return (
        <div className="form-checkbox" style={style}>
            <div className="d-flex">
                <div className={`check-area ${disabled ? 'div-disabled' : ''}`} onClick={() => !disabled && setChecked(!checked)}>
                    <i className={`material-icons ${checked ? 'checked' : 'check'} ${disabled ? 'div-disabled' : ''}`}>
                        {checked ? Constants.icons.CHECK_BOX : Constants.icons.CHECK_BOX_OUTLINE_BLANK}
                    </i>
                    <span className="label">{label}</span>
                    {toolTip && (
                        <span>
                            <OverlayTrigger overlay={<Tooltip id="prerequisite-hint">{toolTip}</Tooltip>} placement="bottom">
                                <i className="material-icons-outlined align-middle hint">{Constants.icons.ERROR_OUTLINE}</i>
                            </OverlayTrigger>
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InputCheckboxWithTooltip;
